import { useContext, useState } from 'react';
import { List, ListItem, ListItemText, Menu, MenuItem } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Settings } from '@material-ui/icons';
import { applicationContext, appUserContext } from 'helpers/services';


let AdminMenu = () => {
    let { currentUser } = useContext(appUserContext);

    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    let handleOpen = (e: any) => {
        setAnchorEl(e.currentTarget);
    }

    let onClose = () => {
        setAnchorEl(null);
    }

    return (
        <>
            <List component="nav" disablePadding>
                <ListItem button onClick={(e) => handleOpen(e)}>
                    <ListItemText primary={<Settings />} />
                </ListItem>
            </List>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={onClose}
            >
                {currentUser?.canManageTicketSettings &&
                    <div>
                        <MenuItem component={RouterLink} to={'/admin/ticketstatus'} onClick={onClose}>Tickets Status</MenuItem>
                        <MenuItem component={RouterLink} to={'/admin/tickettypes'} onClick={onClose}>Ticket Types</MenuItem>
                        <MenuItem component={RouterLink} to={'/admin/ticketPriorites'} onClick={onClose}>Ticket Priorities</MenuItem>
                        <MenuItem component={RouterLink} to={'/admin/assegneeSuggestions'} onClick={onClose}>Assegnee suggestions</MenuItem>
                    </div>
                }
                {currentUser?.claimsPlatformAdmin &&
                    <MenuItem component={RouterLink} to={'/admin/referenceData'} onClick={onClose}>Reference Data</MenuItem>
                }
                {currentUser?.canManageVitecUsers &&
                    <MenuItem component={RouterLink} to={'/admin/usergroups'} onClick={onClose}>User Groups</MenuItem>
                }
                {currentUser?.canManageCustomerUsers &&
                    <MenuItem component={RouterLink} to={'/admin/customers'} onClick={onClose}>Customers</MenuItem>
                }
                {currentUser?.canManageVitecUsers &&
                    <MenuItem component={RouterLink} to={'/admin/users'} onClick={onClose}>Users</MenuItem>
                }

            </Menu>
        </>
    )
}

export default AdminMenu;